/** @file Which command input keys name an entity, and the kind a command domain's `target` names. */

/** `keys`: input key → kind; `targets` / `nestedTargets`: domain → kind of a top-level / nested `target`; `commandTargets`: per-command override of a top-level `target`. */
export const REF_RULES = {
  keys: {
    parent: 'bone', bone: 'bone', parentBone: 'bone', slot: 'slot', image: 'image', skin: 'skin', socket: 'socket',
    item: 'attachment', attachment: 'attachment', animation: 'animation', event: 'event',
  },
  targets: {
    bone: 'bone', slot: 'slot', attachment: 'attachment', mesh: 'attachment', skin: 'skin', ik: 'ik', event: 'event',
    socket: 'socket', reference: 'reference', image: 'image',
  },
  nestedTargets: { ik: 'bone' },
  commandTargets: { 'ik.create': 'bone' },
} as const;
